import { Button, Card, TextField, Typography } from "@material-ui/core";
import { observer } from "mobx-react-lite";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useApp } from "../context";
import { ErrorMessage } from "./ErrorMessage";

export const LoginRoute = observer(function LoginRoute() {
  const app = useApp();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [state, setState] = React.useState({ email: "", password: "" });

  if (app.parse.user) {
    return (
      <ErrorMessage
        icon="fa:exclamation-circle"
        title={t("login-already-logged-in")}
        message="..."
      />
    );
  }

  return (
    <Card style={{ width: "400px", padding: "20px", margin: "20px auto" }}>
      <Typography component="h1" variant="h5" align="center">
        {t("login-title")}
      </Typography>
      <form
        noValidate
        onSubmit={function handleSubmit(event) {
          event.preventDefault();

          app.parse.login(state.email, state.password).then(
            () => {
              navigate("/admin");
            },
            (error) => {
              app.notifications.error(error.message);
            },
          );
        }}
      >
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="email"
          label={t("login-email-label")}
          name="email"
          autoComplete="email"
          autoFocus
          onChange={(e) => {
            setState((cur) => ({ ...cur, email: e.target.value }));
          }}
        />
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          name="password"
          label={t("login-password-label")}
          type="password"
          id="password"
          autoComplete="current-password"
          onChange={(e) => {
            setState((cur) => ({ ...cur, password: e.target.value }));
          }}
        />
        <Button type="submit" fullWidth variant="contained" color="primary">
          {t("button-submit")}
        </Button>
      </form>
    </Card>
  );
});
